import { route as brandInvoiceTokenRoute } from "@faire/web-api--source/routes/www/brand-invoice/brandInvoiceToken";
import { route as brandAppLandingPageRoute } from "@faire/web-api--source/routes/www/brands/app";
import { route as careersRoute } from "@faire/web-api--source/routes/www/careers";
import { route as confirmIdentityRoute } from "@faire/web-api--source/routes/www/confirm-identity";
import { route as expandingBusinessesOfferRoute } from "@faire/web-api--source/routes/www/expanding-businesses-offer";
import { route as expandingBusinessesOfferApplyRoute } from "@faire/web-api--source/routes/www/expanding-businesses-offer/apply";
import { route as netTermsOpenWithFaireApplicationRoute } from "@faire/web-api--source/routes/www/net-terms/owf-application";
import { route as openWithFaireRoute } from "@faire/web-api--source/routes/www/open-with-faire";
import { route as pointOfSaleOnboardingRoute } from "@faire/web-api--source/routes/www/point-of-sale/onboarding";
import { route as pointOfSaleOrderManagerRoute } from "@faire/web-api--source/routes/www/point-of-sale/order-manager/orderToken";
import { route as retailerSettingsInsiderMembershipRoute } from "@faire/web-api--source/routes/www/retailer/settings/insider-membership";
import { route as smallBusinessGrantRoute } from "@faire/web-api--source/routes/www/small-business-grant";
import { route as insiderTermsOfServiceRoute } from "@faire/web-api--source/routes/www/tos-insider";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { matchPathWithLocale } from "@faire/web/common/routing/react-utils";

export const isInBlockedPath = () => {
  const isInBlockedPath = PROMOTION_BLOCKED_PATHS.some(
    (route) =>
      !!matchPathWithLocale(getWindowOrThrow().location.pathname, route)
  );

  return isInBlockedPath;
};

// Keep this list alphabetically sorted
const PROMOTION_BLOCKED_PATHS = [
  brandAppLandingPageRoute,
  brandInvoiceTokenRoute,
  careersRoute,
  confirmIdentityRoute,
  expandingBusinessesOfferApplyRoute,
  expandingBusinessesOfferRoute,
  insiderTermsOfServiceRoute,
  netTermsOpenWithFaireApplicationRoute,
  openWithFaireRoute,
  pointOfSaleOnboardingRoute,
  pointOfSaleOrderManagerRoute,
  retailerSettingsInsiderMembershipRoute,
  smallBusinessGrantRoute,
];
